export const xlsxPicker = {
	sheetHumanizeErrorMessage: {
		verifyBaseSheet:
			", please check the sample spreadsheet template or use it as a base spreadsheet.",
		unidentifieldColumn: "Column names error",
		emptySheet: "This worksheet is empty",
		emptySheetRows: "This spreadsheet has empty lines, please remove the empty lines.",
		emptyHeaderCell: "Missing name in columns",
		sheetPoorlyFormatted:
			"Format spreadsheet for Calibri font, size 11, remove spaces, unnecessary line breaks and bold",
		default: "There was an error importing the sheet",
	},
	sheetNameExample: "(example)",
	sheetNameInvalid: "(invalid)",
	sheetDownload: "Download sample table",
	sheetXlsxPicker: "Choose a worksheet",
	sheetFeedback: {
		successMessage: "Valid worksheet!",
		errorMessage: "Invalid worksheet, download it again and make the necessary changes.",
	},
	duplicateError:
		"Duplicate values have been identified in the uploaded spreadsheet.\n\nPlease review the file, correct the duplicate items and upload again to continue.",
	invalidSheetFormat:
		"The uploaded spreadsheet has an invalid format for this place.\n\nPlease use the correct format based on the place's country and upload again.",
	columns: {
		name: "Name",
		category: "Category",
		menuCategory: "Menu category",
		description: "Description",
		image: "Image",
		hasAlcohol: "Contains alcohol?",
		price: "Price",
		variablePrice: "Variable price",
		kind: "Product type",
		fiscalCode: "SKU",
		ncm: "Fiscal - NCM",
		cest: "Fiscal - CEST",
		fiscalProductGroup: "Fiscal - Tax group",
		fiscalProfile: "Fiscal - Tax profile",
		id: "Product ID",
		products: "products",
		bars: "Bars",
		beerBrand: "Beer brand",
		beerStyle: "Beer style",
		beerAbv: "ABV - Alcohol by volume",
		isStockable: "Stockable",
		fileName: "products_{{placeName}}",
	},
	cell: {
		trueHasAlcohol: "TRUE",
		falseHasAlcohol: "FALSE",
	},
};
